/* eslint-disable no-plusplus */
import React from 'react';
import styled, { keyframes } from 'styled-components';

const fade = keyframes`
    0% {
        opacity: 1
    }
    100% {
        opacity: 0;
    }
`;

type WrapperProps = {
  size: number;
  sizeUnit: string;
};

const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => `${props.size}${props.sizeUnit}`};
  height: ${(props) => `${props.size}${props.sizeUnit}`};
`;

type BarProps = {
  size: number;
  sizeUnit: string;
  rotate: number;
  countBars: number;
  index: number;
  translateOffset: number;
};

const Bar = styled.div<BarProps>`
  position: absolute;
  width: ${(props) => `${props.size / 10}${props.sizeUnit}`};
  height: ${(props) => `${props.size / 4}${props.sizeUnit}`};
  background-color: ${({ theme, color }) =>
    color || (theme as any).color.primary};

  opacity: 0.05;
  transform: ${(props) => `rotate(${props.rotate}deg)`}
    ${(props) => `translate(0, ${props.translateOffset}${props.sizeUnit})`};
  animation: ${fade} ${(props) => props.countBars * 0.06}s linear infinite;
  animation-delay: ${(props) => props.index * 0.06}s;
`;

type GetBarsProps = {
  countBars: number;
  color: string;
  size: number;
  sizeUnit: string;
};

const getBars = ({
  countBars,
  color,
  size = 1,
  sizeUnit = 'rem',
}: GetBarsProps) => {
  const bars = [];
  for (let i = 0; i < countBars; i++) {
    const rotate = (360 / countBars) * i;
    const translate = -(size / 2);
    bars.push(
      <Bar
        countBars={countBars}
        color={color}
        size={size}
        rotate={rotate}
        translateOffset={translate}
        key={i.toString()}
        index={i}
        sizeUnit={sizeUnit}
      />,
    );
  }
  return bars;
};

type SpinnerProps = {
  loading?: Boolean;
  size?: number;
  color?: string;
  sizeUnit?: string;
};

const Spinner = ({
  size = 1,
  color = '',
  loading = true,
  sizeUnit = 'rem',
}: SpinnerProps) => {
  const countBars = 16;
  return (
    loading && (
      <Wrapper size={size} sizeUnit={sizeUnit}>
        {getBars({
          countBars,
          color,
          size,
          sizeUnit,
        })}
      </Wrapper>
    )
  );
};

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Spinner;
